import { Controller } from '@hotwired/stimulus'
import { Chart } from 'chart.js/auto'
import { colors, barChartOptions, doughnutChartOptions } from '~/javascript/charts/chart_config'

export default class extends Controller {
  static values = {
    platformDistribution: Object,
    weeklyOptins: Object,
    topWearables: Object,
    topGoals: Object
  }

  static targets = ['platform', 'weekly', 'wearables', 'goals']

  connect() {
    this.charts = []
    this.initCharts()
  }

  disconnect() {
    this.charts.forEach((chart) => chart.destroy())
  }

  initCharts() {
    this.initPlatformChart()
    this.initWeeklyChart()
    this.initWearablesChart()
    this.initGoalsChart()
  }

  initPlatformChart() {
    if (!this.hasPlatformTarget) return

    const data = this.platformDistributionValue
    const chart = new Chart(this.platformTarget, {
      type: 'doughnut',
      data: {
        labels: data.labels,
        datasets: [{
          data: data.data,
          backgroundColor: colors.chart.slice(0, data.labels.length),
          borderColor: '#ffffff',
          borderWidth: 2
        }]
      },
      options: doughnutChartOptions
    })
    this.charts.push(chart)
  }

  initWeeklyChart() {
    if (!this.hasWeeklyTarget) return

    const data = this.weeklyOptinsValue
    const chart = new Chart(this.weeklyTarget, {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: [{
          data: data.data,
          backgroundColor: colors.neutral[900],
          borderColor: colors.neutral[900],
          borderWidth: 2
        }]
      },
      options: barChartOptions
    })
    this.charts.push(chart)
  }

  initWearablesChart() {
    if (!this.hasWearablesTarget) return

    const data = this.topWearablesValue
    const chart = new Chart(this.wearablesTarget, {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: [{
          data: data.data,
          backgroundColor: colors.neutral[900],
          borderColor: colors.neutral[900],
          borderWidth: 2
        }]
      },
      options: {
        ...barChartOptions,
        indexAxis: 'y',
        scales: {
          ...barChartOptions.scales,
          x: {
            ...barChartOptions.scales.y,
            beginAtZero: true
          },
          y: {
            ...barChartOptions.scales.x,
            grid: { display: false }
          }
        }
      }
    })
    this.charts.push(chart)
  }

  initGoalsChart() {
    if (!this.hasGoalsTarget) return

    const data = this.topGoalsValue
    const chart = new Chart(this.goalsTarget, {
      type: 'bar',
      data: {
        labels: data.labels,
        datasets: [{
          data: data.data,
          backgroundColor: colors.neutral[600],
          borderColor: colors.neutral[900],
          borderWidth: 2
        }]
      },
      options: {
        ...barChartOptions,
        indexAxis: 'y',
        scales: {
          ...barChartOptions.scales,
          x: {
            ...barChartOptions.scales.y,
            beginAtZero: true
          },
          y: {
            ...barChartOptions.scales.x,
            grid: { display: false }
          }
        }
      }
    })
    this.charts.push(chart)
  }
}
